module.exports = __webpack_public_path__ + "img/telegram.a504ec06.svg";